import { createSlice } from "@reduxjs/toolkit";

const produkKeranjang =
  JSON.parse(sessionStorage.getItem("produkKeranjang")) || [];

export const produkSlice = createSlice({
  name: "produk",
  initialState: {
    keyword: "",
    idKategori: 0,
    kategoriProduk: "Semua",
    produkKeranjang: [...produkKeranjang],
  },
  reducers: {
    cariProduk: (state, action) => {
      state.keyword = action.payload.keyword;
    },
    cariKategoriProduk: (state, action) => {
      state.idKategori = action.payload.id_kategori;
      state.kategoriProduk = action.payload.kategori;
    },
    tambahProduk: (state, action) => {
      let item = action.payload;
      state.produkKeranjang.push({
        id_produk: item.id_produk,
        gambar: item.gambar,
        nama_produk: item.nama_produk,
        harga_jual: item.harga_jual,
        jumlah: 1,
        diskon: (item.harga_diskon != 0) ? item.harga_jual - item.harga_diskon : 0,
        laba: item.laba,
      });
      sessionStorage.setItem(
        "produkKeranjang",
        JSON.stringify(state.produkKeranjang)
      );
    },
    tambahJumlahBeliProduk: (state, action) => {
      let indexProduk = state.produkKeranjang.findIndex(
        (obj) => obj.id_produk === action.payload.id
      );
      state.produkKeranjang[indexProduk].jumlah += 1;
      sessionStorage.setItem(
        "produkKeranjang",
        JSON.stringify(state.produkKeranjang)
      );
    },
    kurangJumlahBeliProduk: (state, action) => {
      let indexProduk = state.produkKeranjang.findIndex(
        (obj) => obj.id_produk === action.payload.id
      );

      if (state.produkKeranjang[indexProduk].jumlah > 1) {
        state.produkKeranjang[indexProduk].jumlah -= 1;
        sessionStorage.setItem(
          "produkKeranjang",
          JSON.stringify(state.produkKeranjang)
        );
      }
    },
    hapusProduk: (state, action) => {
      let dataBaru = state.produkKeranjang.filter(
        ({ id_produk }) => id_produk !== action.payload.id
      );
      sessionStorage.setItem("produkKeranjang", JSON.stringify(dataBaru));
      state.produkKeranjang = dataBaru;
    },
    hapusSemuaProduk: (state, action) => {
      let dataBaru = [];
      sessionStorage.setItem("produkKeranjang", JSON.stringify(dataBaru));
      state.produkKeranjang = dataBaru;
    },
  },
});

export const {
  cariProduk,
  cariKategoriProduk,
  tambahJumlahBeliProduk,
  kurangJumlahBeliProduk,
  hapusProduk,
  tambahProduk,
  hapusSemuaProduk,
} = produkSlice.actions;
export default produkSlice.reducer;
